import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { PassagerService } from "../../../core/services/passager/passager.service";
import { MatTableDataSource } from "@angular/material/table";
import { PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { Router } from "@angular/router";
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  switchMap,
} from "rxjs/operators";
import { fromEvent } from "rxjs";
import { MatDialogConfig, MatDialog } from "@angular/material/dialog";
import { CardmodalComponent } from "../../freepassenger-ticket/cardmodal/cardmodal.component";

@Component({
  selector: "app-freepassenger-ticket",
  templateUrl: "./freepassenger-ticket.component.html",
  styleUrls: ["./freepassenger-ticket.component.css"],
})
export class FreepassengerTicketComponent implements OnInit {
  @ViewChild("searchInput") searchInput: ElementRef;

  page: any;
  size: any;
  passengerlist: any;

  displayedColumns = ["id", "numero", "nom", "contact", "cni", "action"];
  dataSource = new MatTableDataSource();
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  userprivileges: any;
  ispopup: boolean = false;
  card: any;
  channel = new BroadcastChannel("ticketrefresh");

  constructor(
    private passengerService: PassagerService,
    private changedetect: ChangeDetectorRef,
    private dialog: MatDialog,
    private router: Router,
  ) {
    this.searchInput = {} as ElementRef;
    this.sort = new MatSort();
    this.userprivileges = localStorage.getItem("authority");
    this.userprivileges = JSON.parse(this.userprivileges);
  }

  ngOnInit(): void {
    this.getpassengerlist();
    let cardcontain: any = localStorage.getItem("card");
    cardcontain = JSON.parse(cardcontain);
    this.card = cardcontain;

    this.channel.onmessage = (response) => {
      let cardcontain: any = localStorage.getItem("card");
      cardcontain = JSON.parse(cardcontain);
      this.card = cardcontain;
    };
  }

  getpassengerlist(): any {
    const page = this.page != null || this.page != undefined ? this.page : 0;
    const size = this.size != null || this.size != undefined ? this.size : 10;
    this.passengerService
      .getAllPassagerList(page, size)
      .subscribe((response: any) => {
        this.passengerlist = response;
        this.dataSource = new MatTableDataSource(response["content"]);
        this.changedetect.detectChanges();
        // console.log(response);
      });
  }

  applyFilter(filterValue: string): any {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  nextPage(event: PageEvent): any {
    this.page = event.pageIndex;
    this.size = event.pageSize;
    this.passengerService
      .getAllPassagerList(this.page, this.size)
      .subscribe((newPageData: any) => {
        this.passengerlist = newPageData;
        this.dataSource = new MatTableDataSource(this.passengerlist?.content);
      });
  }

  editPassenger(data: any): any {}

  viewPassengerTrip(data: any): any {
    // console.log(data);
    // this.router.navigate(['/passengertravel/', data.idpassager], {
    //   state: {
    //    voyage: data
    //   },
    // });

    let id = data.idpassager.replace("/", "%2F");
    let url = this.router.serializeUrl(
      // this.router.createUrlTree([`mail/${decodeURI('#')}collis/edit/${data.idcollis}`])
      this.router.createUrlTree([
        `gev/${decodeURI("#")}/passengertravel/${id}`,
      ]),
    );
    url = url.replace("%23", "#");
    window.open(url, "_blank");
  }

  ngAfterViewInit(): any {
    fromEvent<any>(this.searchInput.nativeElement, "keyup")
      .pipe(
        map((event) => event.target.value),
        debounceTime(1000),
        distinctUntilChanged(),
        filter((query: string) => query?.length > 2),
        switchMap((searchParam) =>
          this.passengerService.searchpassenger(searchParam.trim()),
        ),
      )
      .subscribe((searchResults: any) => {
        this.dataSource = new MatTableDataSource(searchResults.content);
        this.passengerlist = searchResults;
      });
  }

  opencard(): any {
    this.ispopup = true;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    // dialogConfig.position={
    //   right:'110px',
    // };
    dialogConfig.data = {};
    const dialogref = this.dialog.open(CardmodalComponent, {
      width: "auto",
      height: "auto",
      autoFocus: true,
      disableClose: dialogConfig.disableClose,
      data: {
        // ticket: this.ticketmultipleselections,
        // freeticket : true
      },
    });

    dialogref.afterClosed().subscribe((result: any) => {
      this.ispopup = false;
      // this.card = [];
      // localStorage.removeItem('card');
      this.getpassengerlist();
    });
  }

  printPassengerTrip(data: any): any {
    // console.log(data);
    this.passengerService
      .getpassengerTripListWithPhoneAndName(data.nompassager, data.contact)
      .subscribe(
        (response: any) => {
          // console.log(response);
        },
        (error: any) => {
          console.log("error ", error);
        },
      );
  }
}
